import { Box, Flex, Image } from '@chakra-ui/react';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import WorkspaceMenu from './workspace-menu';
import NavigationMenu from './navigation-menu';
import UserMenu from './user-menu';
import { useAuth } from '@/lib/hooks/use-auth';
import useWorkspace from '@/lib/hooks/use-workspace';

export default function Navigation() {
  const { workspaceId } = useParams();
  const { workspace } = useWorkspace();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/auth/login');
  };

  return (
    <Box as='header' position='sticky' top={0} zIndex={11} bg='bg'>
      <Box mx='auto' width={{ md: '90%' }} maxW='6xl' pt={{ base: 0, md: 4 }}>
        {/* Coach Hub TopNav: a single white bar — logo + workspace switcher on the
            left, primary links pushed to the right, profile at the far edge. */}
        <Flex
          as='nav'
          bg='bg.panel'
          borderWidth='1px'
          borderColor='border'
          borderRadius={{ base: 0, md: 'lg' }}
          shadow='sm'
          px={{ base: 4, md: 5 }}
          py={2}
          align='center'
          gap={4}
        >
          <Flex align='center' gap={4} flex='none' minW={0}>
            {workspace && (
              <NavLink to={`/${workspaceId}/home`} style={{ display: 'flex' }}>
                <Box display={{ base: 'none', xl: 'block' }}>
                  <Image
                    src={workspace?.logo || '/logo_horizontal.png'}
                    alt={workspace?.name || 'Coach Hub'}
                    height='24px'
                    fit='contain'
                  />
                </Box>
                <Box display={{ base: 'block', xl: 'none' }}>
                  <Image
                    src={workspace?.logo || '/logo.png'}
                    alt={workspace?.name || 'Coach Hub'}
                    h={5}
                    fit='contain'
                  />
                </Box>
              </NavLink>
            )}
            <WorkspaceMenu currentWorkspaceId={workspaceId} />
          </Flex>

          <Box ml='auto' minW={0}>
            <NavigationMenu />
          </Box>

          <Box flex='none'>
            <UserMenu workspaceId={workspaceId} handleLogout={handleLogout} />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
}
